<template>
  <v-sheet max-width="800" class="mx-auto mt-2 mt-md-6 mt-lg-12" v-if="$route.query.source === 'espaceMembre'">
    <v-alert type="warning" text dismissible>
      <div v-html="$t('avertissements.redirectionDepuisEspaceMembre')"></div>
    </v-alert>
  </v-sheet>
</template>

<script>
export default {}
</script>

<style>
</style>